/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';
import { FormFieldValue, FormValidator } from 'src/core/types/form';
import * as numberValidators from 'src/core/utils/formValidators/numberValidators';
import * as stringValidators from 'src/core/utils/formValidators/stringValidators';

const messages = defineMessages({
    errorMessage: {
        id: 'portal.createLengthValidator.errorMessage',
        defaultMessage: 'Value cannot exceed {maxCharCount} characters.'
    }
});

/**
 * A factory to create a char length validator. A required validator is simply
 * one that succeeds only if the value given is non empty or whitespace.
 */
export const createLengthValidator = (length: number): FormValidator => (value: FormFieldValue) => {
    let validationResult: boolean;

    if (typeof value === 'number') {
        validationResult = numberValidators.createLengthValidator(length)(value);
    }
    if (typeof value === 'string') {
        validationResult = stringValidators.createLengthValidator(length)(value);
    }

    if (!validationResult) {
        return { messageDescriptor: messages.errorMessage, params: { maxCharCount: length } };
    }
};
